import { createFileRoute } from '@tanstack/react-router';
import PortalAccessPage from '../../../../../pages/portal/PortalAccessPage';

export const Route = createFileRoute(
  '/_authenticated/$owner/active/$team_season_id/portal'
)({
  component: RouteComponent
});

function RouteComponent() {
  return <PortalAccessPage />;
}
